import { Backdrop, Button, CircularProgress } from '@mui/material'
import React, { useState, useEffect } from 'react'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
    Avatar,
    Card,
    FormControl,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Input,
    MenuItem,
    Select,
    Stack,
    Chip
} from "@mui/material";
import { ProductDetails } from './ProductDetails';
import { ImagePopup } from "./ImagePopup";
import { ServiceApi } from '../../services/index.service';
import { useNavigate } from "react-router-dom";

export default function ManageMerchandise(props) {
const navigate                                = useNavigate();
const [products, setProducts]                 = useState([])    //For Whole Products List
const [openDialog, setOpenDialog]             = useState(false);
const [openImage, setOpenImage]               = useState(false);
const [dialogAction, setDialogAction]         = useState("add")
const [imageData, setImageData]               = useState({})
const [loading, setLoading]                   = useState(false);
const [categoriesList, setCategoriesList]     = useState([]);
const serviceapi                              = new ServiceApi();
const [payloadForProductEdit, setPayload]     = useState({'httpMethod' : "PATCH", 'payload' : {}})
const [selectedCategory, setSelectedCategory] = React.useState(0);
const productDetails                          = {
    id          : null,
    name        : "",
    cateogry_id : null,
    attributes  : "{}",
    created_at  : "",
    description : "",
    images      : [],
    status      : true,
    stock       : 0,
    updated_at  : "",
    price       : "",
    reviews     : ""
}
const [currentProduct, setCurrentProduct]     = useState(productDetails);


    let productsList = products;
    if (selectedCategory !== 0) {
        productsList = products?.filter(
        (i) => i?.category_id === selectedCategory
        );
    }

    const getPurchaseMerchendise = async () => {
        setLoading(true);
        const response = await serviceapi?.fetchPurchaseMerchendise();
        setLoading(false);
        setCategoriesList(response.Categories);
        let productList = response.Products
        productList.forEach((product) => {
            product.edit = false;
          });
        setProducts(productList);
        //setProductsList(productList);
    };

    useEffect(() => {
        getPurchaseMerchendise();
    }, [])

    const handleConfirmDialog = () => {
        setOpenDialog(!openDialog);
    }

    const openImagePopup = (item) => {
        setImageData(item)
        setOpenImage(!openImage);
    }

    const handleImagePopup = () => {
        setOpenImage(!openImage);
    }

    const openAddProductPopup = () => {
        const {...currentProduct} = {};
        setCurrentProduct(currentProduct);
        setDialogAction("add");
        setOpenDialog(!openDialog);
    }
    const openEditProductPopup = (rowIndex) => {
        //exclude edit and inStock attributes 
        const {...currentProduct } =  productsList[rowIndex];
        setCurrentProduct(currentProduct);
        setDialogAction("edit");
        setOpenDialog(!openDialog);
    }

    const saveChanges = async (payload) => {
        try{
            const response = await serviceapi?.updatePurchaseMerchandise(payload);
            getPurchaseMerchendise();
        } catch (error) {
            console.log(error);
        }
    }

    //List Of Actions to pass to child components
    const callBackFunctions = {
        'saveChanges' : saveChanges
    }

    //This Method is responsible to switch b/w edit and normal views of a table row
    //and Save the changes made by the user if any.
     const switchViews = async (rowIndex) => {

        const updatedProductsList =  [...productsList];

        //If edit attribute is true, then save the changes by making an API call
        if (updatedProductsList[rowIndex].edit) {
            let updatedPayload = {...payloadForProductEdit};
            updatedPayload.payload = {...payloadForProductEdit.payload}
            let id = updatedProductsList[rowIndex]['id'];
            updatedPayload.payload['id'] = id
            setLoading(true); 
            saveChanges(updatedPayload);
            setCurrentProduct(productDetails);
            setLoading(false);
        }

        updatedProductsList[rowIndex] = {...updatedProductsList[rowIndex], 'edit': !updatedProductsList[rowIndex].edit}
        //exclude edit and inStock attributes 
        const {...currentProduct } =  productsList[rowIndex];
        setCurrentProduct(currentProduct)
        //setProductsList(updatedProductsList);
        setPayload({'httpMethod' : "PATCH"})
    }

    const handleChange =(value, item) => {

        if (item == "stock" || item == "price") {
            // Using a regular expression to allow only numeric input
            const numericValue = value.replace(/\D/g, '');
            value = numericValue;
        }

        if (item == "size") {
            let attributes = JSON.parse(currentProduct.attributes);
            attributes.size = value;
            value = JSON.stringify(attributes);
            item = "attributes"
        }

        setCurrentProduct({...currentProduct, [item] : value});
        setPayload(
            {...payloadForProductEdit,
                 payload:
                 {  ...payloadForProductEdit.payload,
                     [item] : value
                }
            })
    }
    const handleGoBack=()=>{
         if(props.directUrl){
            navigate('/buy-merchandise')
        }else{
            navigate('/purchase-merchendise')
        }
    }
    return (
        <>
            <div className="py-6 mt-16">
                {/* HEADER */}
                <header >
                    <div className="flex justify-between items-center mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                        <div className="flex flex-col" onClick={() => handleGoBack()}>
                            <h1 className="text-2xl font-display font-medium leading-tight text-secondary cursor-pointer">
                                <ArrowBackIcon style={{ cursor: 'pointer' }} />
                            
                                    Manage Merchandise
                                </h1>
                            
                        </div>
                        {/* CATEGORY FILTERS */}
                        <div className="flex justify-end gap-2 items-baseline">
                            <div className=" pl-2">
                            <Stack spacing={1} alignItems="center">
                                <Stack direction="row" spacing={2}>
                                <Chip
                                    label="All"
                                    color={
                                    selectedCategory === 0 ? "primary" : "default"
                                    }
                                    onClick={() => setSelectedCategory(0)}
                                />
                                {categoriesList?.map((category) => (
                                    <>
                                    <Chip
                                        label={category?.name}
                                        key={category?.id}
                                        color={
                                        selectedCategory === category?.id
                                            ? "primary"
                                            : "default"
                                        }
                                        onClick={() =>
                                        setSelectedCategory(category?.id)
                                        }
                                    />
                                    </>
                                ))}
                                </Stack>
                            </Stack>
                            </div>
                        </div>
                        {/* ADD NEW PRODUCT */}
                        <div className="flex justify-end gap-4 items-baseline">
                            <Button onClick={openAddProductPopup} variant="outlined" color="error" >
                                Add Product
                            </Button>
                        </div>
                    </div>
                </header>
                <main className="production-sheet mx-auto max-w-7xl px-2 py-4">
                    <div className="">
                        <Card className="mx-6 my-2 bg-white">
                            <TableContainer component={Paper}>
                                <Table  aria-label="simple table">
                                    {/* TABLE HEAD */}
                                    <TableHead>
                                        <TableRow className="bg-[#f2f2f2]">
                                            <TableCell style={{ color: '#D41042', width: '75px' }} >Image</TableCell>
                                            <TableCell style={{ color: '#D41042', width: '400px' }}
                                                align="left"
                                            >
                                                Product Name
                                            </TableCell>
                                            <TableCell style={{ color: '#D41042' ,  width: '120px'  }}
                                                align="left"
                                            >
                                                Category
                                            </TableCell>
                                            <TableCell style={{ color: '#D41042' ,  width: '120px'  }}
                                                align="left"
                                            >
                                                Price
                                            </TableCell>
                                            <TableCell style={{ color: '#D41042', width: '120px' }}
                                                align="left"
                                            >
                                                Type
                                            </TableCell>
                                            
                                            <TableCell style={{ color: '#D41042',  width: '120px'  }}
                                                align="left"
                                            >
                                                In Stock
                                            </TableCell>
                                            <TableCell style={{ color: '#D41042', width: '175px' }}
                                                align="left"
                                            >
                                                Actions
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>

                                    {/* TABLE BODY */}
                                    <TableBody>
                                        {productsList.map((row, rowIndex) => {
                                            const categoryName=categoriesList?.find(i=>i?.id===row?.category_id)?.name || ""
                                            const productThumbnail = (row.images !== 'NA' && row.images !== '') ? JSON.parse(row.images) : 'NA';
                                            return (
                                                <TableRow key={`${row?.id}`}>
                                                    {/* THUMBNAIL */}
                                                    <TableCell align="left">
                                                        <Avatar sx={{ margin: 'auto', bgcolor: '#fff' }} variant="rounded" >
                                                            <img 
                                                                src={productThumbnail[0]?.thumbnail} 
                                                                style={{ height: '100%' }}
                                                                onClick={() => openImagePopup({
                                                                    'img_thumbs' : productThumbnail[0]?.thumbnail,
                                                                    'name'       : row?.name })
                                                                }
                                                                alt={'productImage'}
                                                                className='cursor-pointer' 
                                                            />
                                                        </Avatar>
                                                    </TableCell>

                                                    {/* PRODUCT NAME */}
                                                    <TableCell align="left">
                                                        { row?.edit ?  
                                                            <Input 
                                                                id="productname" 
                                                                variant="filled" 
                                                                size="small"
                                                                value={currentProduct?.name}
                                                                onChange={(event) => handleChange(event.target.value, "name" )}
                                                            />
                                                           : row?.name
                                                        }
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {categoryName}
                                                    </TableCell>
                                                    {/* PRICE */}
                                                    <TableCell align="left">
                                                        { row?.edit ?  
                                                            <Input 
                                                                id="price" 
                                                                variant="filled" 
                                                                size="small"
                                                                value={currentProduct?.price}
                                                                onChange={(event) => handleChange(event.target.value, "price" )}
                                                                inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                                            />
                                                           : '$' + row?.price
                                                        }
                                                        
                                                    </TableCell>

                                                    {/* SIZE */}
                                                    <TableCell align="left">
                                                        { row?.edit ?  
                                                                <FormControl sx={{ maxWidth: 120, minWidth: 120 }} size="small">
                                                                    <Select
                                                                    value={JSON.parse(currentProduct?.attributes)?.size}
                                                                    size="small"
                                                                    onChange={(e) =>
                                                                        handleChange(e.target.value, "size")
                                                                    }
                                                                    >
                                                                        <MenuItem key="S" value="S">
                                                                        S (small)
                                                                        </MenuItem>
                                                                        <MenuItem key="M" value="M">
                                                                        M (Medium)
                                                                        </MenuItem>
                                                                        <MenuItem key="L" value="L">
                                                                        L (Large)
                                                                        </MenuItem>
                                                                        <MenuItem key="XL" value="XL">
                                                                        XL (Extra Large)
                                                                        </MenuItem>
                                                                    </Select>
                                                                </FormControl>
                                                            : (row?.attributes !== 'NA' && row?.attributes !== '') ? JSON.parse(row?.attributes)?.size : 'NA'
                                                        }
                                                    </TableCell>

                                                    {/* IN STOCK */}
                                                    <TableCell align="left">
                                                       { row?.edit ?  
                                                            <FormControl sx={{ maxWidth: 120, minWidth: 120 }} size="small">
                                                            <Select
                                                              value={currentProduct?.status}
                                                              size="small"
                                                              onChange={(e) =>
                                                                handleChange(e.target.value, "status")
                                                              }
                                                            >
                                                                <MenuItem key="Yes" value={true}>
                                                                  Yes
                                                                </MenuItem>
                                                                <MenuItem key="No" value={false}>
                                                                  No
                                                                </MenuItem>
                                                              
                                                            </Select>
                                                          </FormControl>  
                                                           : row?.status ? 'Yes' : 'No'
                                                        }
                                                    </TableCell>

                                                    {/* ACTIONS */}
                                                    <TableCell align="left">
                                                        
                                                        <Button 
                                                            onClick={() => openEditProductPopup(rowIndex)} 
                                                            //className="float-right" 
                                                            variant='contained' 
                                                            color={row?.edit ? 'error' : 'error'} 
                                                            style={{ background: row?.edit ? 'green' :  '#d32f2f'  }}
                                                            size="small"
                                                        >
                                                            Edit
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        }
                                        )
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Card>
                    </div>
                </main>
            </div>
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            {openDialog &&
                <ProductDetails openDialog={openDialog}
                    handleConfirmDialog={handleConfirmDialog}
                    imageData={imageData} categoriesList={categoriesList}
                    action = {dialogAction}
                    productDetails={currentProduct}
                    callBackFunctions = {callBackFunctions}
                    refreshData={getPurchaseMerchendise}
                />
            }
            {openImage && <ImagePopup openDialog={openImage} handleConfirmDialog={handleImagePopup} imageData={imageData} />}

        </>
    )
}
